module.exports = __webpack_public_path__ + "static/media/productIntroductionBanner.22ec17ae.png";